module.exports = __webpack_public_path__ + "assets/fonts/a4d477e8-9ca2-4c2a-bbae-1ade3d5b0db5.52c5c6d0.ttf";